import Cookies from 'js-cookie';
import { STORAGE_KEY } from 'src/constants/app';

const storage = Cookies;
const authInfoStorage = Cookies;
// const authInfoStorage = localStorage;
// const storage = localStorage;

export class LocalStorage {
  static get accessToken() {
    return storage.get(STORAGE_KEY.ACCESS_TOKEN) || null;
    // return storage.getItem(STORAGE_KEY.ACCESS_TOKEN) || null;
  }

  static get refreshToken() {
    return storage.get(STORAGE_KEY.REFRESH_TOKEN) || null;
    // return storage.getItem(STORAGE_KEY.REFRESH_TOKEN) || null;
  }

  static get authInfo(): Model.Me {
    return JSON.parse(authInfoStorage.get(STORAGE_KEY.AUTH_ME_INFO) || 'null');
    // return JSON.parse(
    //   authInfoStorage.getItem(STORAGE_KEY.AUTH_ME_INFO) || 'null',
    // );
  }

  static setToken(payload: any) {
    let expires =
      payload.expired_at || new Date().setTime(new Date().getTime() + 14400);
    storage.set(STORAGE_KEY.ACCESS_TOKEN, payload.access_token, {
      path: '/',
      expires: expires,
    });
    let expiresRefreshToken = new Date();
    expiresRefreshToken.setTime(expiresRefreshToken.getTime() + 86400 * 1000);
    storage.set(STORAGE_KEY.REFRESH_TOKEN, payload.refresh_token, {
      path: '/',
      expires: expiresRefreshToken,
    });

    // storage.setItem(STORAGE_KEY.ACCESS_TOKEN, payload.access_token);
    // storage.setItem(STORAGE_KEY.REFRESH_TOKEN, payload.refresh_token);
  }

  static saveAuthInfo(payload: any) {
    const {
      id,
      first_logged_in_at,
      email,
      show_iva_gmail,
      name,
      profile_picture,
      roles,
    } = payload;
    const authInfo = {
      id,
      first_logged_in_at,
      email,
      show_iva_gmail,
      name,
      profile_picture,
      roles: roles.map((role: any) => {
        return {
          id: role.id,
          name: role.name,
        };
      }),
    };
    authInfoStorage.set(STORAGE_KEY.AUTH_ME_INFO, JSON.stringify(authInfo));
    // authInfoStorage.setItem(STORAGE_KEY.AUTH_ME_INFO, JSON.stringify(authInfo));
  }

  static removeInfo() {
    storage.remove(STORAGE_KEY.ACCESS_TOKEN);
    storage.remove(STORAGE_KEY.REFRESH_TOKEN);
    authInfoStorage.remove(STORAGE_KEY.AUTH_ME_INFO);
    // storage.removeItem(STORAGE_KEY.ACCESS_TOKEN);
    // storage.removeItem(STORAGE_KEY.REFRESH_TOKEN);
    // authInfoStorage.removeItem(STORAGE_KEY.AUTH_ME_INFO);
  }
}

export default LocalStorage;
